// extracted by mini-css-extract-plugin
export default {"Pearl":"Pearl-module__Pearl--sJJrV"};